import AiAgentVersionsAPI from 'dashboard/api/aiAgents/versions';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

// Versions are immutable (D06) — read-only module scoped per brain.
export default createStore({
  name: 'AiAgentVersion',
  API: AiAgentVersionsAPI,
  actions: mutations => ({
    get: async ({ commit }, { brainId }) => {
      commit(mutations.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await AiAgentVersionsAPI.get({ brainId });
        commit(mutations.SET, response.data.payload);
        return response.data.payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
      }
    },
    show: async ({ commit }, { brainId, id }) => {
      commit(mutations.SET_UI_FLAG, { fetchingItem: true });
      try {
        const response = await AiAgentVersionsAPI.show({ brainId, id });
        commit(mutations.UPSERT, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { fetchingItem: false });
      }
    },
  }),
});
